<div class="vehicle-container">
  @for (vehicleInfo of displayVehicles; track vehicleInfo) {
  <div>
    <h3 class="cui-h3 mb-xxs" [attr.data-pgr-id]="'lblVehicleModel'">
      Policy Vehicle: {{ vehicleInfo.modelName }}
      {{
        vehicleInfo.statedAmount > 0
          ? "(Stated Amount: " +
            (vehicleInfo.statedAmount | currency: "USD") +
            ")"
          : ""
      }}
    </h3>
    <div class="coverage-vehicle-desc p-xxs mb-xxs rounded">
      @if (displayVehicles != null) {
      <cui-data-list [border]="false" class="coverages-no-wrap">
        @for (vehCoverage of vehicleInfo.coverage; track vehCoverage; let i =
        $index) {
        <cui-data-list-row [label]="vehCoverage.description">
          <div [attr.data-pgr-id]="'lblVehCoverageLimitDescription.' + i">
            {{ vehCoverage.limitsDescription }}
          </div>
        </cui-data-list-row>
        }
      </cui-data-list>
      }
    </div>
  </div>
  }
</div>
